import $firebaseAuth from '../../FireORMModelSharedRecources/$firebaseAuth'
import { ModelDef } from '../index'

const model: ModelDef = {
  tableName: 'users',
  tableLabel: 'ユーザ管理',
  tableComment: '',
  timestamps: true,
  defaultSort: { key: 'email', order: 'asc' },
  useAlgolia: false,
  columns: {
    name: {
      label: '名前',
      type: 'STRING',
      validate: { notEmpty: true },
      searchable: true,
      editable: true,
      editableOnCreate: true,
    },
    email: {
      label: 'メールアドレス',
      type: 'STRING',
      validate: { notEmpty: true },
      searchable: true,
      unique: true,
      editable: false,
      editableOnCreate: true,
    },
  },
  showOnMainmenu: false,
  showOnSettingMenu: true,
  shouldCreateHistoryData: ({ before, after }) => false,
  beforeCreate: async (data) => {
    /**
     * create auth user before create user in firestore
     */
    // FIXME: set random password and send email for password reset.
    const [userCredential, error] = await $firebaseAuth.createUserWithEmailAndPassword(data.email, 'testtesttest')
    if (error) {
      throw error
    }
    data.id = userCredential.user.uid
    return data
  },
}

export default model
